import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Drawer, Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const Popup4868 = () => {
  const [open, setOpen] = useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };

  return (
    <>
      <Drawer
        className="exit-popup"
        anchor="left"
        onClose={handleClose}
        open={open}
        variant="temporary"
        PaperProps={{
          sx: {
            maxWidth: { xs: 320, sm: 450 },
            background: '#f9f5f2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            px: 2,
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 2 }}
            alignItems="center"
            justifyContent="space-around"
          >
            <Box sx={{ textAlign: { xs: 'center', sm: 'center' } }}>
              <Box
                component="img"
                src="/assets/images/deadline-img.png"
                alt="Wait! Don’t Miss Your Tax Extension!"
                sx={{ maxWidth: { xs: 150, sm: 150, md: 150, lg: 200 }, mt: 3 }}
              />
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 18, sm: 20, md: 22 },
                  color: '#da4b4b',
                  mb: 1,
                }}
              >
                Wait! Don’t Miss <br />
                <span style={{ color: '#333' }}> Your Extension!</span>{' '}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: 13, sm: 15, md: 17 },
                  mb: 2,
                  lineHeight: 1.5,
                }}
              >
                The <span style={{ fontWeight: 600 }}>Form 4868</span> deadline
                is{' '}
                <span style={{ fontWeight: 600, color: '#da4b4b' }}>
                  April 15, 2026
                </span>
              </Typography>
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'column' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            sx={{}}
          >
            <Box>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: 12, sm: 13, md: 15 },
                  mt: 1.5,
                  textAlign: 'center',
                  maxWidth: 580,
                  mx: 'auto',
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Need more time to file your individual tax return (Form 1040)?
                </span>{' '}
                E-file Form 4868 now to avoid IRS late-filing penalties.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  fontWeight: 600,
                }}
              >
                Exclusive Offer:
              </Typography>

              <Box
                sx={{
                  m: 0,
                  mx: 'auto',
                  mb: 2,
                  maxWidth: 350,
                  p: 1,
                  fontSize: { xs: 11, sm: 12, md: 14 },
                  fontWeight: 400,
                  lineHeight: 1.2,
                  border: '2px dashed rgb(113, 81, 0)',
                  backgroundColor: 'rgb(255, 250, 205)',
                }}
              >
                Use code
                <br />
                <Box
                  component="strong"
                  sx={{
                    ml: 0,
                    color: '#fd5345',
                    fontWeight: 600,
                    fontSize: { xs: 16, sm: 18, md: 20 },
                  }}
                >
                  TZOEXT10
                </Box>
                <br />
                at checkout for
                <br />
                <b>10% off your filing fee! </b>
              </Box>
            </Box>
          </Stack>
        </Box>

        <Box sx={{ px: { xs: 1, sm: 3 }, mb: 1, textAlign: 'center' }}>
          <Typography
            variant="body2"
            sx={{
              fontSize: 16,
              fontWeight: 500,
              my: 1,
              fontStyle: 'italic',
            }}
          >
            Don&apos;t risk late penalties
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              textTransform: 'none',
              boxShadow: 'none',
              borderRadius: 3,
              display: 'inline-block',
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form4868&utm_source=exit+pop+up`}
          >
            E-File & Save 10%
          </Button>
          {/* <Typography
              variant="body1"
              sx={{
                fontSzie: 16,
                fontWeight: 500,
                mt: 1,
                fontStyle: 'italic',
              }}
            >
              At <strong>10% OFF</strong>
            </Typography> */}
        </Box>
      </Drawer>
    </>
  );
};

export default Popup4868;
